import $ from 'jquery';
import config from './../../config';
const URL_API = config.urlApi+'controlador/expediente/getExpedientes.php';

export default function getExpedientes(){
    return $.ajax({
        url: URL_API,
        type: 'GET'
    })
}